export enum RowType {
    OA,
    OA_CHILD,
    MI2,
    FLOA,
    WP, // winning %
    FLMI2,
    FLWP, // Front Line Winning %
}
